export enum ClaimEmailMaxLengths {
  SubjectCharacters = 256,
  RecipientCharacters = 256,
  CCCharacters = 256,
  BodyCharacters = 20000,
}
